module.exports = {"150726101":"嵯岗镇","150726102":"阿木古郎镇","150726202":"新宝力格苏木乡","150726203":"乌布尔宝力格苏木乡","150726204":"罕达盖苏木","150726205":"吉布胡郎图苏木","150726206":"甘珠尔苏木","150726400":"嵯岗双娃牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150726.json
// module id = 406
// module chunks = 0